/* eslint-disable react/react-in-jsx-scope */
import Tooltip from "@mui/material/Tooltip";

import { Box } from "@mui/material";
/* eslint-disable react/prop-types */
const CustomImage = ({
  filename,
  height,
  width,
  paddingTop,
  paddingRight,
  marginLeft,
  marginBottom,
  alt,
  marginRight,
  colorvalue,
  marginTop,
  borderRadius,
  TooltipText,
  allowTooltip = false,
  onClick,
  borderWidth = 0,
  borderColor = "",
  placement = "top",
  arrow,
}) => {
  let open = allowTooltip ? true : false;
  return (
    // eslint-disable-next-line react/react-in-jsx-scope
    <>
      {!open ? (
        <Tooltip arrow={arrow} title={TooltipText} placement={placement}>
          <Box>
            {" "}
            <img
              onClick={onClick}
              alt={alt}
              src={filename}
              style={{
                cursor: "pointer",
                width: width,
                height: height,
                paddingTop: paddingTop ? paddingTop : 0,
                paddingRight: paddingRight ? paddingRight : 0,
                marginLeft: marginLeft ? marginLeft : 0,
                marginBottom: marginBottom ? marginBottom : 0,
                marginRight: marginRight ? marginRight : 0,
                backgroundColor: colorvalue ? "red" : "transparent",
                marginTop: marginTop ? marginTop : 0,
                borderRadius: borderRadius ? borderRadius : 0,
                borderWidth: borderWidth,
                borderColor: borderColor,
                borderStyle: "solid",
              }}
            />{" "}
          </Box>
        </Tooltip>
      ) : (
        <div className="tooltip">
          <img
            onClick={onClick}
            alt={alt}
            src={filename}
            style={{
              cursor: "pointer",
              width: width,
              height: height,
              paddingTop: paddingTop ? paddingTop : 0,
              paddingRight: paddingRight ? paddingRight : 0,
              marginLeft: marginLeft ? marginLeft : 0,
              marginBottom: marginBottom ? marginBottom : -2,
              marginRight: marginRight ? marginRight : 0,
              backgroundColor: colorvalue ? "red" : "transparent",
              marginTop: marginTop ? marginTop : 0,
              borderRadius: borderRadius ? borderRadius : 0,

              // resize:"contain"
            }}
          />

          {open && <span className="tooltiptext">{TooltipText}</span>}
        </div>
      )}
    </>
  );
};

export default CustomImage;
